import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    paymentMethod: {
      label: {
        id: 'properties.paymentMethod',
        defaultMessage: 'Payment method',
        description: 'label of the payment method field',
      },
    },
    paymentMethodIssuer: {
      label: {
        id: 'properties.paymentMethodIssuer',
        defaultMessage: 'Bank',
        description: 'label of the payment method issuer field',
      },
    },
  },
};

export default defineMessages(translations);
